/*
  HAKRO size pills, length picker and cart line properties for the product form.

  Sizes are not Shopify variants; every colour variant carries its sizes in the
  metafield plytix.available_sizes (CSV) which the colour swatch exposes as
  data-available-sizes. This script

  - renders the size pills into #dynamic-size-buttons for the selected colour
    (the quantity table variant is rendered by variant-selects.js),
  - keeps the colour variant id in input[name="id"] in sync,
  - maintains the hidden line item properties Size, _Title and Modellnummer.

  Configuration is read from the <variant-selects> element:
    data-section, data-form-id, data-size-display, data-product-title,
    data-model-code, data-enable-length, data-length-label, data-qty-label.
*/
(function () {
  function parseAvailableSizes(sizesCSV) {
    const raw = String(sizesCSV || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    const sizes = [];

    for (let i = 0; i < raw.length; i++) {
      const current = raw[i];
      const next = raw[i + 1];
      const third = raw[i + 2];

      // "41,41,5" is a half size written with a comma: 41 and 41.5
      if (/^\d+$/.test(current) && next === current && third === '5') {
        sizes.push(current, `${current}.5`);
        i += 2;
        continue;
      }

      sizes.push(current);
    }

    return [...new Set(sizes)];
  }

  function ensureHiddenInput(name, formId) {
    let input = document.querySelector(`input[name="${name}"][type="hidden"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('form', formId);
      document.body.appendChild(input);
    }
    return input;
  }

  function initVariantSelects(root) {
    if (root.dataset.hakroOptionsInit === 'true') return;
    root.dataset.hakroOptionsInit = 'true';

    const sectionId = root.dataset.section || '';
    const formId = root.dataset.formId || `product-form-${sectionId}`;
    const useTable = root.dataset.sizeDisplay === 'table';
    const enableLength = root.dataset.enableLength === 'true';
    const productTitle = root.dataset.productTitle || '';
    const lengthLabel = root.dataset.lengthLabel || '';
    const qtyLabel = root.dataset.qtyLabel || '';
    const baseModelCode = root.dataset.modelCode || '';

    const sizeContainer = root.querySelector('#dynamic-size-buttons') || document.getElementById('dynamic-size-buttons');
    const lengthContainer = document.getElementById('dynamic-length-buttons');
    const idInput = document.querySelector(`#${formId} input[name="id"]`) || document.querySelector('input[name="id"]');
    const submitBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const colorInputs = Array.from(
      root.querySelectorAll('fieldset input[type="radio"]:not([name^="properties["])')
    );

    let variants = [];
    try {
      const data = root.querySelector('script[type="application/json"]');
      variants = data ? JSON.parse(data.textContent) : [];
    } catch (e) {
      variants = [];
    }

    const sizeInput = ensureHiddenInput('properties[Size]', formId);
    const titleInput = ensureHiddenInput('properties[_Title]', formId);
    const modelCodeInput = ensureHiddenInput('properties[Modellnummer]', formId);

    function updateProperties() {
      const selectedSizeRadio = document.querySelector('input[name="properties[_Size]"]:checked');
      const firstTableQty = sizeContainer
        ? Array.from(sizeContainer.querySelectorAll('.size-qty-table__input')).find(
            (input) => parseInt(input.value, 10) > 0
          )
        : null;
      const selectedLengthRadio = lengthContainer
        ? lengthContainer.querySelector('input[type="radio"]:checked')
        : null;

      const size = selectedSizeRadio ? selectedSizeRadio.value : firstTableQty ? firstTableQty.dataset.size : '';
      const lengthValue = selectedLengthRadio ? selectedLengthRadio.value : '';
      const lengthKey = selectedLengthRadio ? selectedLengthRadio.dataset.lengthKey : '';

      sizeInput.value = size ? size.toUpperCase() : '';

      titleInput.value = enableLength && lengthValue ? `${productTitle} | ${lengthLabel}: ${lengthValue}` : productTitle;

      // Model code by length: regular keeps 0791, short -> 791S, long -> 791L
      if (enableLength && lengthKey && baseModelCode) {
        let modifiedCode = baseModelCode;
        if (lengthKey === 'short') {
          modifiedCode = baseModelCode.replace(/^0+/, '') + 'S';
        } else if (lengthKey === 'long') {
          modifiedCode = baseModelCode.replace(/^0+/, '') + 'L';
        }
        modelCodeInput.value = modifiedCode;
      } else {
        modelCodeInput.value = baseModelCode;
      }
    }

    function renderSizePills(sizesCSV) {
      if (!sizeContainer) return;
      // The quantity table is owned by variant-selects.js.
      if (useTable || sizeContainer.dataset.sizeDisplay === 'table') return;

      sizeContainer.innerHTML = '';
      sizeContainer.classList.remove('size-qty-table');
      if (!sizesCSV) return;

      parseAvailableSizes(sizesCSV).forEach((size) => {
        const inputId = 'size-' + size.toLowerCase().replace(/[^a-z0-9]/g, '-');

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'properties[_Size]';
        input.value = size;
        input.id = inputId;
        input.setAttribute('form', formId);
        input.addEventListener('change', updateProperties);

        const label = document.createElement('label');
        label.htmlFor = inputId;
        label.textContent = size.toUpperCase();

        sizeContainer.appendChild(input);
        sizeContainer.appendChild(label);
      });
    }

    function updateVariantId() {
      if (!variants.length) return;
      const selectedColor = colorInputs.find((input) => input.checked);
      const variant = selectedColor && variants.find((v) => v.option1 === selectedColor.value);

      if (variant && idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.remove('disabled');
        }
      }
    }

    // variant-selects.js delegates pill rendering to this hook
    window.renderSizes = renderSizePills;

    colorInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if ('availableSizes' in input.dataset) renderSizePills(input.dataset.availableSizes);
        updateVariantId();
        updateProperties();
      });

      if (input.checked) {
        if ('availableSizes' in input.dataset) renderSizePills(input.dataset.availableSizes);
        updateVariantId();
      }
    });

    if (sizeContainer) {
      sizeContainer.addEventListener('change', () => {
        updateVariantId();
        updateProperties();
      });
    }

    if (lengthContainer) {
      lengthContainer.addEventListener('change', updateProperties);
    }

    updateProperties();
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(initVariantSelects);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
